import { useLocale } from "next-intl";
import {
  convertDate,
  type discountType,
  formatPrice,
  montserrat,
  type searchPricesType,
} from "utils";
import { useAppConfiguration } from "appConfig";

interface IPriceCardPriceAndDiscountProps {
  t: any;
  item: searchPricesType;
}

export function PriceCardPriceAndDiscount({
  t,
  item,
}: IPriceCardPriceAndDiscountProps) {
  const locale = useLocale();
  const { isJinnyApp } = useAppConfiguration();

  function getPrice(beforePrice: number, price: number, currency: string) {
    if (beforePrice > price) {
      return (
        <div className="flex flex-row gap-2">
          <span
            className={`${montserrat.className}  font-semibold line-through decoration-[#737373] decoration-2`}
          >
            {formatPrice(Number(beforePrice), currency)}
          </span>
          <span
            className={`${montserrat.className}  font-bold ${isJinnyApp ? "text-[#69ad3a]" : "text-green"}`}
          >
            {formatPrice(Number(price), currency)}
          </span>
        </div>
      );
    } else {
      return (
        <p className={`${montserrat.className}  font-semibold `}>
          {formatPrice(Number(price === 0 ? beforePrice : price), currency)}
        </p>
      );
    }
  }

  function getDiscounts(
    discounts: discountType[],
    beforePrice: number,
    price: number,
    currency: string
  ) {
    if (!discounts || discounts.length === 0 || beforePrice <= price)
      return null;

    return discounts.map((discount, index) => (
      <div
        key={index}
        className={discount.discountAmount === 0 ? "hidden" : ""}
      >
        <div className="flex flex-row flex-wrap items-center gap-1 text-greenAttention text-[14px]">
          <span className="font-bold whitespace-nowrap uppercase after:content-['_-_']">
            {t("Prices.discount")}
          </span>
          <span className="whitespace-nowrap">
            {discount.name !== "" ? discount.name : t("Prices.defaultDiscount")}
          </span>
          <span className="whitespace-nowrap">
            (-
            {formatPrice(
              discount.discountGrossAmount ?? discount.discountAmount,
              currency
            )}
            )
          </span>
        </div>
        <div className="flex flex-row flex-wrap items-center gap-1 text-orange text-[14px]">
          <span className="font-bold whitespace-nowrap after:content-[':']">
            {t("Coupons.validTillDay")}
          </span>
          <span className="whitespace-nowrap ms-1">
            {convertDate(discount.validUntil, "simpleDateFormat", locale)}
          </span>
        </div>
      </div>
    ));
  }

  return (
    <>
      <div className="bg-gray-200 flex flex-row justify-center rounded-xl p-4">
        {getPrice(item?.beforePrice, item?.price, item?.currency)}
      </div>
      <div className="min-h-[50px] my-2">
        {getDiscounts(
          item?.discounts,
          item?.beforePrice,
          item?.price,
          item?.currency
        )}
      </div>
    </>
  );
}
